import * as yup from "yup";

export const messageSpecificationSchema = yup.object({
  name: yup.string(),
  dataType: yup.string(),
  value: yup.string(),
});
